import { formatPrice, ProductPriceDisplay } from '@libs/common-next';
import { type BuyItAgainItem } from '@libs/common-types';

export const Price = ({ price }: { price: BuyItAgainItem['price'] }) => {
    const isOnSale = Boolean(price.saleValidUntil && new Date(price.saleValidUntil) >= new Date());

    if (price.type === 'range') {
        const displayPrice = isOnSale && price.sale ? price.sale : price.original;

        return (
            <ProductPriceDisplay
                fromPrice={formatPrice(displayPrice.from)}
                isOnSale={isOnSale && Boolean(price.sale)}
                toPrice={formatPrice(displayPrice.to)}
                type="range"
            />
        );
    }

    const salePrice = isOnSale ? price.sale : undefined;

    return (
        <ProductPriceDisplay
            originalPrice={salePrice ? formatPrice(price.original) : undefined}
            price={formatPrice(salePrice ?? price.original)}
            type="default"
        />
    );
};
